// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscacidadeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaCidade() /localidades/buscaCidade
 *
 * Proxy to locations-service (Go microservice).
 * Returns a single city record by ID.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_BuscacidadeResponseDados {
id?: number
name?: string
state_id?: number
}

export type Localidades_BuscacidadeResponse = ApiResponse<Localidades_BuscacidadeResponseDados>;

registerResponseContract('Localidades_BuscacidadeResponse', {
  id:       { type: 'number',  required: false },
  name:     { type: 'string',  required: false },
  state_id: { type: 'number',  required: false },
})
